import React from 'react';

type ModalSubSectionProps = {
  children: React.ReactNode;
  title: string;
};

export const ModalSubSection = ({ children, title }: ModalSubSectionProps): JSX.Element => {
  return (
    <div className="modal-sub-section--container">
      <span className="modal-sub-section--title">{title}</span>
      {children}
    </div>
  );
};
